import React from 'react';
import SEO from '../components/SEO';

function About() {
  // SEO structured data
  const seoStructuredData = {
    '@context': 'https://schema.org',
    '@type': 'AboutPage',
    'name': 'About Pharmaceutical Database',
    'description': 'Comprehensive pharmaceutical research platform integrating FDA, NIH, and EMBL-EBI databases'
  };

  return (
    <div className="page-container">
      <SEO
        title="About - Pharmaceutical Database"
        description="Pharmaceutical Database integrates FDA Drugs@FDA, Orange Book, ClinicalTrials.gov, ChEBI, ChEMBL, PubChem, RxNorm, and DailyMed. Free access to comprehensive drug information for healthcare professionals and researchers."
        keywords="about pharmaceutical database, drug information platform, FDA databases, clinical trials, chemical data, healthcare research"
        canonical="/about"
        structuredData={seoStructuredData}
      />
      <h1 className="page-title">About Pharmaceutical Database</h1>
      <p className="page-description">
        Your comprehensive source for pharmaceutical research and drug information
      </p>

      <div style={{ maxWidth: '900px', margin: '0 auto' }}>
        <section style={{ marginBottom: '3rem' }}>
          <h2 style={{ color: '#2c3e50', marginBottom: '1rem' }}>Our Mission</h2>
          <p style={{ color: '#7f8c8d', lineHeight: '1.8', fontSize: '1.05rem' }}>
            The Pharmaceutical Database is dedicated to providing healthcare professionals, researchers, 
            and patients with free access to accurate, comprehensive pharmaceutical information from authoritative 
            government sources. We integrate multiple databases to create a unified platform for drug research, 
            clinical trial information, and chemical data.
          </p>
        </section>

        <section style={{ marginBottom: '3rem' }}>
          <h2 style={{ color: '#2c3e50', marginBottom: '1rem' }}>Data Sources</h2>
          <p style={{ color: '#7f8c8d', lineHeight: '1.8', marginBottom: '1rem' }}>
            Our platform integrates data from the following authoritative sources:
          </p>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '1.5rem' }}>
            {[
              { name: 'FDA Drugs@FDA', desc: 'Approved drug products' },
              { name: 'Orange Book', desc: 'FDA approved drugs and therapeutics' },
              { name: 'ClinicalTrials.gov', desc: 'Clinical trial information' },
              { name: 'ChEBI', desc: 'Chemical entities' },
              { name: 'ChEMBL', desc: 'Bioactive molecules' },
              { name: 'PubChem', desc: 'Chemical compounds' },
              { name: 'RxNorm', desc: 'Drug name standardization' },
              { name: 'DailyMed', desc: 'FDA drug labels' }
            ].map((source, idx) => (
              <div key={idx} style={{ padding: '1rem', backgroundColor: '#ecf0f1', borderRadius: '8px' }}>
                <h4 style={{ color: '#2c3e50', marginBottom: '0.5rem' }}>{source.name}</h4>
                <p style={{ color: '#7f8c8d', fontSize: '0.9rem' }}>{source.desc}</p>
              </div>
            ))}
          </div>
        </section>

        <section style={{ marginBottom: '3rem' }}>
          <h2 style={{ color: '#2c3e50', marginBottom: '1rem' }}>Features</h2>
          <ul style={{ color: '#7f8c8d', lineHeight: '2', fontSize: '1.05rem' }}>
            <li>✓ Search across 8 major pharmaceutical databases</li>
            <li>✓ Comprehensive drug information and properties</li>
            <li>✓ Drug interaction checking</li>
            <li>✓ Clinical trial search and information</li>
            <li>✓ Chemical structure and molecular data</li>
            <li>✓ FDA approved medications database</li>
            <li>✓ Recent search history for quick access</li>
            <li>✓ Free access to all data sources</li>
          </ul>
        </section>

        <section>
          <h2 style={{ color: '#2c3e50', marginBottom: '1rem' }}>Technology</h2>
          <p style={{ color: '#7f8c8d', lineHeight: '1.8', marginBottom: '1rem' }}>
            Built with modern web technologies:
          </p>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '1rem' }}>
            {[
              { tech: 'Frontend', tools: 'React, React Router, Axios' },
              { tech: 'Backend', tools: 'Node.js, Express, Sequelize' },
              { tech: 'Database', tools: 'MySQL 8.0' },
              { tech: 'DevOps', tools: 'Docker, Docker Compose' }
            ].map((item, idx) => (
              <div key={idx} style={{ padding: '1rem', backgroundColor: '#f8f9fa', borderRadius: '8px' }}>
                <h4 style={{ color: '#2c3e50', marginBottom: '0.5rem' }}>{item.tech}</h4>
                <p style={{ color: '#7f8c8d', fontSize: '0.9rem' }}>{item.tools}</p>
              </div>
            ))}
          </div>
        </section>
      </div>
    </div>
  );
}

export default About;
